<audio controls><source src="{{{o.url}}}" type="audio/mpeg"></audio>
<a target="_blank" rel="noopener" href="{{{o.url}}}">{{{o.label_download}}}</a>
